import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';

const LIST_TAB = {
  newsAggregators: 1,
  autoNews: 2,
  premiumAnalysis: 3,
  expertView: 4,
  rumors: 5,
};

class SwitchTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        { value: `premiumAnalysis`, index: 3 },
        { value: `expertView`, index: 4 },
        { value: `autoNews`, index: 2 },
        { value: `newsAggregators`, index: 1 },
      ],
    };
    const { user, handleSwitchTab } = this.props;
    if (isNotLoginOrExpired(user)) {
      handleSwitchTab(LIST_TAB.newsAggregators, 'currentTab');
    }
  }

  onclickTab = value => {
    const { handleSwitchTab, user } = this.props;
    if (isNotLoginOrExpired(user) && value !== 'newsAggregators') {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }

    handleSwitchTab(LIST_TAB[value], 'currentTab');
  };

  render() {
    const { listTab } = this.state;
    const { currentTab, user } = this.props;

    return (
      <div className="fa-switch-tab-wrapper">
        {listTab.map(item => {
          return (
            <div
              key={item.value}
              className={`level-item mr-3`}
              onClick={() => this.onclickTab(item.value)}
            >
              <div
                className={`${
                  currentTab === LIST_TAB[item.value]
                    ? 'level-item__title'
                    : 'level-item__title level-item__title--grey'
                }`}
              >
                {I18n.t(`newsAndAnalysis.listTab.${item.value}`)}
                {isNotLoginOrExpired(user) &&
                  item.value !== 'newsAggregators' && (
                    <i className="icon-padlock" />
                  )}
              </div>
              <div
                className={`${
                  currentTab === LIST_TAB[item.value]
                    ? 'level-item__underline level-item__underline--selected'
                    : 'level-item__underline'
                }`}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

export default connect(mapStateToProps)(SwitchTab);
